import React from "react";

export const Stadium = [
  <div className="slideContainer slide_TextImageRight">
    <h4 className="slideTitle">
      HOUSTON, TX – The Houston Dynamo Football Club and Shell Energy have
      signed a letter of intent to make Shell Energy the exclusive energy
      provider of Houston Dynamo FC, the Houston Dash and PNC Stadium.
    </h4>
    <div className="slideText">
      <p>
        As part of this relationship, and to support the Club in achieving its
        goal of reducing its carbon footprint by an estimated 50% by 2026, Shell
        Energy will be implementing integrated energy solutions such as LED
        lighting installation, HVAC system replacements and EV charging stations
        at PNC Stadium. This highlights the shared commitment between the
        Dynamo, the Dash and Shell Energy in building a better energy future
        while improving sustainability today. These efforts will extend to the
        community as well, through programs such as “Trees for Threes”, in which
        the Club and Shell Energy will plant a tree for every game that the
        Dynamo or Dash win which gives the team three points in the league
        standings.
      </p>
    </div>
    <div className="slideImage">
      <img
        src="images/shell-energy-sports-deck-final-us-website.jpg"
        alt=""
        width="560"
        height="auto"
      />
    </div>
  </div>,
];
